import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsLinkComponent extends Component {
  // Defaults
  linkOptions = [
    {
      value: '_self',
      label: '_self',
    },
    {
      value: '_blank',
      label: '_blank',
    },
  ];

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
          />

          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}

            <fieldset.field @property='url' />
            <fieldset.field
              @property='linkOptions'
              @type='select-value'
              @options={{this.linkOptions}}
            />
            <fieldset.field @property='headline' />
            <fieldset.field @property='altText' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
